<template>
	<tr>
		<td :class="{'filter-active': filterClasses.date}">{{ dataVal.date }}</td>
		<td :class="{'filter-active': filterClasses['customer_name']}">{{ dataVal['user'] }}</td>
		<td :class="{'filter-active': filterClasses['driver_name']}">{{ dataVal['text'] }}</td>
		<td>
			<v-btn
					:disabled="dataVal['action_delete'] === 0 || !permissions['9']"
					class="notesBtn"
					color="green"
					icon
					fab
					x-small
					@click="onHandler(dataVal)"
			>
				<v-icon>mdi-pencil</v-icon>
			</v-btn>
			<v-btn
					:disabled="dataVal['action_delete'] === 0 || !permissions['9']"
					class="notesBtn"
					color="green"
					icon
					fab
					x-small
					@click="onDeleteHandler(dataVal)"
			>
				<v-icon>mdi-delete</v-icon>
			</v-btn>
		</td>
	</tr>
</template>

<script>
export default {
	name: "ActionTr",
	props: {
		dataVal: Object,
		employees: Array,
		filterClasses: Object,
		permissions: Object,
		safetyStatus: Array,
		safetyDrivingHours: Array
	},
	computed: {
		getStatusDefault() {
			return this.dataVal['safety_status_id'];
		},
		getTime() {
			// eslint-disable-next-line no-unused-vars
			const [ , time ] = this.dataVal?.create_at.split(' ');
			return time ?? '';
		},
		getHoursDefault() {
			return this.dataVal['driving_hours_id'];
		},
		getEmployeeDefault() {
			return this.dataVal['employee_id'];
		}
	},
	methods: {
		onHandler(values) {
			this.$emit('updateEditActions', values);
		},
		onDeleteHandler(value) {
			this.$emit('deleteHandler', value);
		}
	}
};
</script>

<style scoped lang="scss">
.notesBtn {
	margin-left: 5px;
}

.employees {
	min-width: 150px;
	max-width: 200px;
	text-overflow: ellipsis;
	overflow-x: hidden;
}
</style>
